import { Breadcrumb, CoreButton } from '@components'
import EditReportNameIcon from '@images/expenses/edit-report-name.svg?react'
import LeftArrowIcon from '@images/icons/left-arrow-icon.svg?react'
import { toastSuccess } from '@utils'
import EditRecipientModal from '@views/recipients/EditRecipientModal/EditRecipientModal'
import { paths, useSearchExternalInstrumentsQuery } from 'mmfintech-backend-api'
import { GlobalContext, isValidArray, tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { useContext } from 'react'

import './RecipientDetailsHeader.scss'

const BREADCRUMB_ITEMS: { label: string; path: (id?: string) => string }[] = [
  {
    get label() {
      return tr('FRONTEND.HEADER.REPORTS', 'Reports')
    },
    path: () => paths.expenseManagement.dashboard()
  },
  {
    get label() {
      return tr('FRONTEND.HEADER.COUNTERPARTY', 'Counterparties')
    },
    path: () => paths.expenseManagement.counterparties()
  },
  {
    get label() {
      return tr('FRONTEND.COUNTERPARTY_PAGE_HEADER.COUNTERPARTIES_DETAIL', 'Counterparties Detail')
    },
    path: () => 'back'
  },
  {
    get label() {
      return tr('FRONTEND.RECIPIENT_DETAILS_HEADER.RECIPIENTS_DETAIL', 'Recipients Detail')
    },
    path: (id: string) => paths.recipients.details(id)
  }
]

export const RecipientDetailsHeader = ({ param }) => {
  const { modalHide, modalShow } = useContext(GlobalContext)

  const { recipient, recipientError, recipientFetching } = useSearchExternalInstrumentsQuery(
    { paymentInstrumentId: param },
    {
      selectFromResult: ({ data, isFetching, error }) => ({
        recipient: isValidArray(data?.content) ? data.content[0] : {},
        recipientFetching: isFetching,
        recipientError: error
      })
    }
  )

  const handleEditRecipient = () => {
    modalShow({
      header: tr('FRONTEND.RECIPIENTS.UPDATE.TITLE', 'Edit recipient'),
      content: (
        <EditRecipientModal
          onClose={modalHide}
          onSuccess={() => {
            toastSuccess(tr('FRONTEND.RECIPIENTS.EDIT.SUCCESS_DETAILS.RECIPIENT_EDITED', 'Recipient edited!'))
            modalHide()
          }}
          recipient={recipient}
          independentEdit={true}
        />
      )
    })
  }

  return (
    <div className='recipient-details-page-header'>
      <ErrorDisplay error={recipientError} />
      {!recipientFetching && (
        <>
          <div className='recipient-details-header-title'>
            <div
              onClick={e => {
                e?.preventDefault()
                window.history.back()
              }}
              className='back-arrow-icon'
            >
              <LeftArrowIcon />
            </div>

            <span className='title'>{(recipient as any)?.name}</span>
            <CoreButton
              data-test='open-edit-counterparty-modal'
              onClick={handleEditRecipient}
              CollapsedIcon={<EditReportNameIcon />}
              collapsed
              variation='elevated'
              size='large'
            />
          </div>
          <Breadcrumb items={BREADCRUMB_ITEMS} />
        </>
      )}
    </div>
  )
}
